import { render } from "./StepDescription.vue?vue&type=template&id=25d08030"
import script from "./StepDescription.vue?vue&type=script&lang=js"
export * from "./StepDescription.vue?vue&type=script&lang=js"

import exportComponent from "/Users/williamsandstrom/repos/web/ytopi/ytopi-configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__